interface Param {
  field: string;
  type: string;
  required?: boolean;
  description: string;
}

interface ParamTableProps {
  params: Param[];
  title?: string;
}

export default function ParamTable({ params, title }: ParamTableProps) {
  const showRequired = params.some((p) => p.required !== undefined);

  return (
    <div className="my-4 overflow-x-auto">
      {title && (
        <p className="font-mono text-[10px] text-bone-white/40 uppercase tracking-wider mb-3">{title}</p>
      )}
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b border-navy-800/60">
            <th className="font-mono text-[10px] text-bone-white/40 uppercase tracking-wider py-2.5 pr-6">Field</th>
            <th className="font-mono text-[10px] text-bone-white/40 uppercase tracking-wider py-2.5 pr-6">Type</th>
            {showRequired && (
              <th className="font-mono text-[10px] text-bone-white/40 uppercase tracking-wider py-2.5 pr-6">Required</th>
            )}
            <th className="font-mono text-[10px] text-bone-white/40 uppercase tracking-wider py-2.5">Description</th>
          </tr>
        </thead>
        <tbody>
          {params.map((p) => (
            <tr key={p.field} className="border-b border-navy-800/30">
              <td className="font-mono text-xs text-bone-white/80 py-2.5 pr-6 whitespace-nowrap">{p.field}</td>
              <td className="font-mono text-xs text-sky-400/70 py-2.5 pr-6 whitespace-nowrap">{p.type}</td>
              {showRequired && (
                <td className="font-mono text-xs text-bone-white/50 py-2.5 pr-6">{p.required ? 'Yes' : 'No'}</td>
              )}
              <td className="font-sans text-xs text-bone-white/60 py-2.5">{p.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
